import styled from "@emotion/styled";
import { Box, Tabs, Typography } from "@mui/material";
import Tab from "@mui/material/Tab";
import theme from "../theme";
import { shouldForwardProp } from "./Common.style";

type TabLabelProp = {
  isCurrent: boolean;
};

export const StyledTab = styled(Tab)`
  padding: 7px 9px 7px 9px;
  min-height: 0;
  min-width: 0;
  border: 1px solid ${theme.palette.grey[400]};
`;

export const LeftTabStyle = styled(StyledTab, {
  shouldForwardProp: prop =>
    shouldForwardProp<TabLabelProp>(["isCurrent"], prop),
})<TabLabelProp>(({ isCurrent }) => ({
  borderRadius: "12px 0 0 12px",
  borderRight: "0px",
  backgroundColor: isCurrent
    ? theme.palette.grey[800]
    : theme.palette.common.white,
}));

export const RightTabStyle = styled(StyledTab, {
  shouldForwardProp: prop =>
    shouldForwardProp<TabLabelProp>(["isCurrent"], prop),
})<TabLabelProp>(({ isCurrent }) => ({
  borderRadius: "0 12px 12px 0",
  backgroundColor: isCurrent
    ? theme.palette.grey[800]
    : theme.palette.common.white,
}));

export const TabLabel = styled(Typography, {
  shouldForwardProp: prop =>
    shouldForwardProp<TabLabelProp>(["isCurrent"], prop),
})<TabLabelProp>(({ isCurrent }) => ({
  fontSize: "0.7rem",
  fontWeight: 500,
  color: isCurrent ? theme.palette.common.white : theme.palette.common.black,
}));

export const SwitchTabsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;

  & > * {
    margin-right: 8px;
  }
`;

export const TabsWrapper = styled(Tabs)`
  height: 20px;
  padding: 6px;
  align-items: center;

  & .MuiTabs-indicator {
    display: none;
  }
`;
